import { z } from 'zod'

export const carrierSchema = z.object({
  name: z.string().min(1, 'Name is required').max(100, 'Name must be at most 100 characters'),
  code: z.string().max(10, 'Code must be at most 10 characters').optional(),
  transportModeId: z.number().min(0, 'Transport Mode is required'),
  tenantId: z.number(),
  id: z.number().optional(),
})

export type CarrierFormData = z.infer<typeof carrierSchema>
